<template>
  <div>
    <v-container
      class="my-4 my-md-16 px-6 px-sm-16 px-md-4"
      style="max-width: 1000px"
    >
      <ValidationObserver ref="observer" v-on:keyup.enter="submit">
        <v-row justify="center">
          <v-col cols="12" sm="8" md="5" align="center">
            <img
              :src="
                $vuetify.theme.dark
                  ? require('@/app/core-module/assets/images/LOGO_DARK_MODE.png')
                  : require('@/app/core-module/assets/images/LOGO.png')
              "
              alt="Logo"
              class="mb-10"
              height="100"
              width="auto"
            />

            <v-card elevation="0" class="border-lg">
              <div class="pa-4 pa-md-10">
                <div
                  class="
                    text-subtitle-2
                    textLight--text
                    mt-6
                    mb-2
                    text-start
                    font-weight-thin
                  "
                >
                  {{ $t("user.dontWorry") }}
                </div>

                <div
                  class="
                    text-h5
                    textLight--text
                    mt-3
                    mb-7
                    text-start
                    font-weight-medium
                  "
                >
                  {{ $t("user.resetPassword") }}
                </div>

                <validation-provider v-slot="{ errors }" rules="required|email">
                  <div
                    class="
                      text-start
                      mb-0
                      textLight--text
                      text-subtitle-2
                      font-weight-thin
                    "
                  >
                    {{ $t("user.signIn.yourEmail") }}
                  </div>

                  <v-text-field
                    hide-details
                    v-model="phoneOrEmail"
                    @click="errorFromApi = null"
                    :error-messages="errors"
                    outlined
                    dense
                    :disabled="hasOtp"
                    class="rounded-md text-body-2"
                  >
                  </v-text-field>
                </validation-provider>

                <template v-if="hasOtp">
                  <validation-provider v-slot="{ errors }" rules="required">
                    <div
                      class="
                        text-start
                        mb-0
                        mt-3
                        textLight--text
                        text-subtitle-2
                        font-weight-thin
                      "
                    >
                      {{ $t("user.otp") }}
                    </div>

                    <v-text-field
                      hide-details
                      v-model="otp"
                      @click="errorFromApi = null"
                      :error-messages="errors"
                      outlined
                      dense
                      class="rounded-md text-body-2"
                    >
                    </v-text-field>
                  </validation-provider>

                  <validation-provider
                    v-slot="{ errors }"
                    rules="required"
                    vid="password"
                  >
                    <div
                      class="
                        text-start
                        mb-0
                        mt-3
                        textLight--text
                        text-subtitle-2
                        font-weight-thin
                      "
                    >
                      {{ $t("user.profile.newPassword") }}
                    </div>

                    <v-text-field
                      hide-details
                      v-model="password"
                      @click="errorFromApi = null"
                      :error-messages="errors"
                      outlined
                      dense
                      class="rounded-md text-body-2"
                      :append-icon="passwordValue ? 'mdi-eye-off' : 'mdi-eye'"
                      @click:append="() => (passwordValue = !passwordValue)"
                      :type="passwordValue ? 'password' : 'text'"
                      :password_value="password"
                    >
                    </v-text-field>
                  </validation-provider>

                  <validation-provider
                    v-slot="{ errors }"
                    rules="required|confirmed:password"
                  >
                    <div
                      class="
                        text-start
                        mb-0
                        mt-3
                        textLight--text
                        text-subtitle-2
                        font-weight-thin
                      "
                    >
                      {{ $t("user.confirmPassword") }}
                    </div>

                    <v-text-field
                      hide-details
                      v-model="confirmPassword"
                      @click="errorFromApi = null"
                      :error-messages="errors"
                      outlined
                      dense
                      class="rounded-md text-body-2"
                      :append-icon="
                        confirmPasswordValue ? 'mdi-eye-off' : 'mdi-eye'
                      "
                      @click:append="
                        () => (confirmPasswordValue = !confirmPasswordValue)
                      "
                      :type="confirmPasswordValue ? 'password' : 'text'"
                      :password_value="confirmPassword"
                    >
                    </v-text-field>
                  </validation-provider>
                </template>

                <v-btn
                  @click="submit"
                  :loading="loading"
                  depressed
                  large
                  dark
                  class="text-subtitle-1 rounded-md mb-2 mt-8"
                  color="textLight"
                  style="width: 100%"
                >
                  {{ $t("user.reset").toUpperCase() }}
                </v-btn>

                <div
                  v-if="!hasOtp"
                  class="
                    text-subtitle-2
                    textLight--text
                    mb-2
                    text-center
                    font-weight-thin
                  "
                >
                  {{ $t("user.passwordResetEmail") }}
                </div>

                <p v-if="errorFromApi" class="error--text text-center">
                  {{ errorFromApi }}
                </p>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </ValidationObserver>
    </v-container>
  </div>
</template>

<script>
import "../../core-module/util/validationRules";
import { sendOtp, forgotPassword } from "../methods/forgotPassword";

export default {
  data() {
    return {
      loading: false,
      hasOtp: false,
      phoneOrEmail: null,
      otp: null,
      password: null,
      confirmPassword: null,
      passwordValue: String,
      confirmPasswordValue: String,
      errorFromApi: null,
    };
  },
  methods: {
    submit() {
      if (this.hasOtp) this.forgotPassword();
      else this.sendOtp();
    },
    async sendOtp() {
      const isValid = await this.$refs.observer.validate();

      if (isValid) {
        this.loading = true;

        sendOtp({ phoneOrEmail: this.phoneOrEmail }).then(response => {
          if (response.data) this.hasOtp = true;
          else if (response.error)
            this.errorFromApi = this.$t("somethingWentWrong");

          this.loading = false;
        });
      }
    },
    async forgotPassword() {
      const isValid = await this.$refs.observer.validate();

      if (isValid) {
        this.loading = true;

        const forgotPasswordInput = {
          phoneOrEmail: this.phoneOrEmail,
          otp: this.otp,
          password: this.password,
        };

        forgotPassword(forgotPasswordInput).then(response => {
          if (response.data) {
            this.hasOtp = false;
            this.$router.push({ name: "SignIn" });
          } else if (response.error) {
            if (response.error.includes("OTP_ERROR"))
              this.errorFromApi = this.$t("user.otpError");
            else this.errorFromApi = this.$t("somethingWentWrong");
          }

          this.loading = false;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped />
